<template>
  <div
    :id="reservation.id"
    class="rexer_reservation"
  >
    {{ dataEvent.contact_form_id }}
    <div class="rexer_reservation_form">
      <div class="rexer_reservation_form__inner">
        <div class="rexer_reservation_form__row">
          <h4
            class="rexer_reservation_form__title"
          >
            {{ reservation.event_title }}
          </h4>
          <p class="rexer_reservation_form__subtitle">{{ reservation.event_location }}</p>
          <p class="rexer_reservation_form__subtitle">{{ reservation.event_date | moment("DD.MM.YY, HH.mm") }} UHR</p>
        </div>
        <div class="rexer_reservation_form__row is-flex show-3">
          <div class="rexer_reservation_form__control is-first">
            <input
              v-model="reservation.tickets"
              type="text"
              name="tickets"
              value=""
              class="control"
              min="1"
              max="10"
              aria-invalid="false"
              placeholder="Anzahl Tickets*"
            >
            <div
              v-if="submitted && !$v.reservation.tickets.required"
              class="error"
            >
              {{ error.required }}
            </div>
          </div>
          <div class="rexer_reservation_form__control">
            <input
              v-model.trim="reservation.vorname"
              type="text"
              name="vorname"
              value=""
              class="control"
              placeholder="Vorname*"
            >
            <div
              v-if="submitted && !$v.reservation.vorname.required"
              class="error"
            >
              {{ error.required }}
            </div>
          </div>
          <div class="rexer_reservation_form__control is-last">
            <input
              v-model.trim="reservation.name"
              type="text"
              name="name"
              value=""
              class="control"
              placeholder="Name*"
            >
            <div
              v-if="submitted && !$v.reservation.name.required"
              class="error"
            >
              {{ error.required }}
            </div>
          </div>
        </div>
        <div class="rexer_reservation_form__row is-flex show-2">
          <div class="rexer_reservation_form__control">
            <input
              v-model.trim="reservation.firma"
              type="text"
              name="firma"
              value=""
              class="control"
              placeholder="Firma"
            >
          </div>
          <div class="rexer_reservation_form__control is-last">
            <input
              v-model.trim="reservation.strasse"
              type="text"
              name="strasse"
              value=""
              class="control"
              placeholder="Strasse/Nr*"
            >
            <div
              v-if="submitted && !$v.reservation.strasse.required"
              class="error"
            >
              {{ error.required }}
            </div>
          </div>
        </div>
        <div class="rexer_reservation_form__row is-flex show-2">
          <div class="rexer_reservation_form__control">
            <input
              v-model.trim="reservation.plz"
              type="text"
              name="plz"
              value=""
              class="control"
              placeholder="PLZ/Ort*"
            >
            <div
              v-if="submitted && !$v.reservation.plz.required"
              class="error"
            >
              {{ error.required }}
            </div>
          </div>
          <div class="rexer_reservation_form__control is-last">
            <input
              v-model.trim="reservation.telefon"
              type="text"
              name="telefon"
              value=""
              class="control"
              placeholder="Telefon*"
            >
            <div
              v-if="submitted && !$v.reservation.telefon.required"
              class="error"
            >
              {{ error.required }}
            </div>
          </div>
        </div>
        <div class="rexer_reservation_form__row">
          <div class="rexer_reservation_form__control">
            <input
              v-model.trim="reservation.email"
              type="email"
              name="email"
              value=""
              class="control"
              placeholder="Email*"
            >
            <div
              v-if="submitted && !$v.reservation.email.required"
              class="error">
              {{ error.required }}
            </div>
            <div
              v-if="submitted && !$v.reservation.email.email"
              class="error"
            >
              {{ error.email }}
            </div>
          </div>
        </div>
        <div class="rexer_reservation_form__row">
          <div class="rexer_reservation_form__control">
            <textarea
              v-model="reservation.mitteilung"
              class="control is-textarea"
              placeholder="Mitteilung"
            />
          </div>
        </div>
        <div class="rexer_reservation_form__row">
          <div class="rexer_reservation_form__control is-submit">
            <button
              class="rexer_reservation_form__btn"
              title="Senden"
              @click.prevent="submitHandle"
            >
              <span>Senden</span>
              <i
                class="arrow-right"
                v-html="arrow_right"
              />
            </button>
          </div>
        </div>
      </div>
      <!-- message -->
      <div class="rexer_reservation_message">
        {{ isError }}
        {{ submitStatus }}
      </div>
      <!--// message -->
    </div> <!-- end form-->
    <!-- close-->
    <a
      href="#"
      title="Back"
      class="rexer_reservation_close"
      @click.prevent="backHandle">
      <i
        class="close-btn"
        v-html="close_btn"
      />
    </a>
  </div>
</template>

<script>
import axios from 'axios'
import { svg, env } from '../helpers/config'
import { required, numeric, email } from 'vuelidate/lib/validators'
export default {
  name: 'Reservation',
  props: {
    dataEvent: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isSending: false,
      isValid: false,
      isError: '',
      reservation: {
        id: '',
        event_title: '',
        event_date: '',
        event_location: '',
        tickets: '',
        vorname: '',
        name: '',
        firma: '',
        strasse: '',
        plz: '',
        telefon: '',
        email: '',
        mitteilung: ''
      },
      submitted: false,
      arrow_right: svg.ARROW_RIGHT,
      close_btn: svg.CLOSE,
      submitStatus: '',
      atts: '',
      error: {
        required: 'Das ist ein Pflichtfeld.',
        email: 'Die Emailadresse hat einen Fehler.'
      }
    }
  },
  validations: {
    reservation: {
      event_title: { required },
      event_date: { required },
      event_location: { required },
      tickets: { required, numeric },
      vorname: { required },
      name: { required },
      strasse: { required },
      plz: { required },
      telefon: { required },
      email: { required, email }
    }
  },
  mounted () {
    this.initData()
    this.$nextTick(() => {
      this.atts = this.$root.atts
    })
  },
  methods: {
    submitHandle () {
      if (this.isSending) return
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'Ein oder mehrere Felder sind fehlerhaft. Bitte kontrollieren Sie Ihre Eingaben.'
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'
        this.isSending = true
        let ctfid = this.dataEvent.contact_form_id ? this.dataEvent.contact_form_id : null
        let { reservation } = this
        const url = env.CF7_URL + ctfid + '/feedback'
        let bodyFormData = new FormData()
        bodyFormData.append('event-title', reservation.event_title)
        bodyFormData.append('event-place', reservation.event_location)
        bodyFormData.append('event-time', reservation.event_date)
        bodyFormData.append('event-tickets', reservation.tickets)
        bodyFormData.append('event-vorname', reservation.vorname)
        bodyFormData.append('event-name', reservation.name)
        bodyFormData.append('event-firma', reservation.firma)
        bodyFormData.append('event-strasse', reservation.strasse)
        bodyFormData.append('event-plz', reservation.plz)
        bodyFormData.append('event-tel', reservation.telefon)
        bodyFormData.append('event-email', reservation.email)
        bodyFormData.append('event-mitteilung', reservation.mitteilung)
        try {
          axios({
            method: 'post',
            url: url,
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
            .then(response => {
              // handle success
              if (response.status === 200) {
                this.submitStatus = 'Vielen Dank für Ihre Nachricht, sie wurde erfolgreich versendet.'
              }
            })
            .catch(function (response) {
              // handle error
              console.log(response)
            })
        } catch (error) {
          this.submitStatus = 'Die Nachricht konnte nicht gesendet werden, bitte versuchen Sie es erneut später.'
        } finally {
          setTimeout(() => {
            this.isSending = false
            this.$emit('offHandle')
          }, 1000)
        }
      }
    },
    backHandle () {
      this.$emit('offHandle')
    },
    resetData () {
      this.reservation.id = ''
      this.reservation.event_title = ''
      this.reservation.event_date = ''
      this.reservation.event_location = ''
      this.reservation.tickets = ''
      this.reservation.vorname = ''
      this.reservation.name = ''
      this.reservation.firma = ''
      this.reservation.strasse = ''
      this.reservation.plz = ''
      this.reservation.telefon = ''
      this.reservation.email = ''
      this.reservation.mitteilung = ''
    },
    initData () {
      if (this.dataEvent) {
        let { dataEvent, reservation } = this
        reservation.id = dataEvent.id
        reservation.event_title = dataEvent.title.rendered
        reservation.event_date = dataEvent.date_time
        reservation.event_location = dataEvent.location
      }
    }
  }
}
</script>

<style lang="scss">
$green: #00ff00;
.rexer_reservation {
  background: rgba($green, 0.9);
  padding: 4rem 1rem 2rem;
  min-height: 100vh;
  overflow: hidden;
  * {
    box-sizing: border-box;
  }
  &_form{
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    height: 85vh;
    &__title {
      text-transform: uppercase;
      line-height: 1.4;
      padding-bottom: 0.5rem
    }
    &__subtitle{
      color: #000;
      &:last-child{
        padding-bottom: 1rem;
      }
    }
  }
  &_close {
    display: inline-block;
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    padding: 0.5rem 0;
    .close-btn {
      display: inline-block;
      width: 16px;
    }
  }
  .control {
    width: 100%;
    padding: 0.5rem;
    color: #000;
    border-color: transparent;
    font-size: 1rem;
    margin-bottom: 0.75rem;
    box-sizing: border-box;
    height: 50px;
    line-height: 50px;
    transition: all 330ms ease;
    outline: 0 none;
    &.is-textarea{
      min-height: 120px;
    }
    &:focus, &:active {
      outline: 0 none;
    }
  }
  .error{
    color: #000;
    padding-bottom: 0.5rem;
    font-size: 0.75rem;
    margin-top: -0.5rem;
  }
  &_form__btn {
    background: transparent;
    border: 0;
    cursor: pointer;
    display: flex;
    font-size: 1rem;
    line-height: 1.4;
    height: 50px;
    justify-content: center;
    padding: 0.5rem 0;
    .arrow-right {
      padding-left: 0.5rem;
      width: 30px;
    }
    &:hover, &:active, &:focus{
      outline: 0 none;
    }
  }
}

@media screen and (min-width: 768px) {
  .rexer_reservation {
    $self: &;
    &_form__row{
      &.is-flex {
        display: flex;
        &.show-3 {
          #{$self}_form__control {
            width: 45%;
            padding-right: 1rem;
            &.is-first {
              width: 30%;
            }
            &.is-last {
              padding-right: 0
            }
          }
        }
        &.show-2 {
          #{$self}_form__control {
            width: 50%;
            padding-right: 1rem;
            &.is-last {
              padding-right: 0
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .rexer_reservation_form {
    width: 600px;
    margin: 3rem auto;
  }
}
@media screen and (min-width: 1408px) {
  .rexer_reservation_form {
    margin: 6rem auto;
  }
}
</style>
